<template>
    <div style="height: 100%;">
        <div class="p-personal-center p-personal-center__pc">
            <Header />
            <div class="p-personal-main" :class="{'mt0': isMobile }">
                <SideNav />
                <div class="c-center-content">
                    <div v-show="!isMobile" class="center-content-title">
                        {{title}}
                    </div>
                    <router-view></router-view>
                </div>
            </div>
            <Footer :isLogin="true"/>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideNav from '@/components/personal-center/SideNav';
import MobileNav from '@/components/personal-center/MobileNav';
// import CenterContent from '@/components/personal-center/CenterContent';


export default {
    name: 'PersonalCenter',
    components: {
        SideNav,
        // CenterContent, 
        Header,
        Footer
    },
    watch: {
        $route(to,from) {
            this.title = to.meta.title;
            this.isMobile = to.path.includes('/m-mine');
        }
    },
    data() {
        return {
            title: '',
            isMobile: false
        }
    },
    mounted() {
        this.title = this.$route.meta.title;
        this.isMobile = this.$route.path.includes('/m-mine');
    },
}
</script>

<style scoped>
.p-personal-main{
    width:1200px;
    margin:0 auto;
    background:#F9F9F9;
    min-height: calc(100% - 2rem);
    /* margin-top: .74rem; */
    overflow:hidden;
    margin-bottom:20px;
}
.mt0 {
    margin-top: 0;
}
.p-personal-center{
    background:#F9F9F9;
    /* overflow:hidden */
    /* height: 100%;*/
}
/* 
@media screen and (max-width: 850px){
    .c-side-nav{display:none;}
    .p-personal-main{width:100%;}
    body.pcStyle .header .head-bot{width:100%;}
} */

body.h5Style .p-personal-center__pc {
    display: block;
    height: 100%;
}


.c-center-content{
  width:1005px;
  background:#fff;
  float:right;
  margin-top:20px;
  height: 100%;
  /* min-height: calc(100% - 1.74rem); */
}
.center-content-title{
  line-height:60px;
  border-bottom:1px solid #ddd;
  padding-left:20px;
  color:#333;
  font-size:24px;
  box-sizing:border-box;
}
@import url(./PersonalCenter-m.css);
@media screen and (max-width: 850px){
    .c-side-nav{display:none;}
    .p-personal-main{
        width:100%;
    }
    body.pcStyle .header .head-bot{width:100%;}
    
  .c-center-content{
      width:100%;background:#F9F9F9;margin:0;
   }
  .c-profile-content{
    width: 90%;
    float: unset;
    margin: 0 auto;
  }
  .c-profile-list li{margin-bottom:.4rem;}
  .c-profile-rt-input img{width:.34rem;margin-top:.1rem;}
  .center-content-title{
      border-bottom:none;font-size:.48rem;line-height:.76rem;background:#fff;line-height:1.2rem;
      width:90%;
      /* margin-left:.25rem;margin-top:.25rem; */
        margin: .25rem auto;
        margin-bottom: 0;
    }


    body.h5Style .p-personal-center .header .head-logo,
    body.h5Style .p-personal-center .header .head-login,
    body.h5Style .p-personal-center .header .head-reg {
        display: block !important;
    }

    .header {
        /* position: absolute; */
        left: 0;
        right: 0;
        top: 0;
        z-index: 2;
        background-color: #201F5F;
        /* background: url(../assets/header/bg-head.png); */
    }
    .head-bot {
        margin-left: auto;
        margin-right: auto;
        padding-top: 24px;
        padding-bottom: 14px;
        display: block;
        width: 1180px;
        height: 36px;
        display: flex;
        justify-content: space-between;
    }
    .header .head-logo {
        margin-top: -2px;
        width: 147px;
        height: 39px;
        background: url(../assets/logo.png) no-repeat left top;
        background: url(../assets/logo@2x.png) no-repeat left top/auto 0.32rem;
        cursor: pointer;
    }


}
</style>